// PORTED FROM apps/web — see apps/web-employer/PORTING.md (or web-admin/) for follow-ups

import * as React from "react";
import { useNavigate } from "react-router-dom"; // TODO: useRouter → useNavigate (nav(x) → nav(x), router.replace(x) → nav(x, {replace:true}))
import { useTranslations } from "next-intl";
import { Eye } from "lucide-react";
import type { OrgKycSubmissionAdmin } from "@chotca/config";
import { useAdminOrgKycList } from "@chotca/api-client";
import {
  DataTable,
  usePagination,
  type Column,
  type RowAction,
} from "@/components/data-table";

export function OrgsListClient() {
  const t = useTranslations("admin");
  const nav = useNavigate();
  const { page, pageSize, setPage, setPageSize } = usePagination();
  const { data, isLoading, isFetching } = useAdminOrgKycList({
    page,
    limit: pageSize,
  });
  const items = (data?.items ?? []) as OrgKycSubmissionAdmin[];

  const columns: Column<OrgKycSubmissionAdmin>[] = [
    {
      key: "legalName",
      header: "Tên pháp lý",
      cell: (s) => (
        <span className="font-semibold text-ink">{s.legalName}</span>
      ),
    },
    {
      key: "taxCode",
      header: "Mã số thuế",
      cell: (s) => <span className="font-mono text-xs">{s.taxCode}</span>,
    },
    {
      key: "rep",
      header: "Người đại diện",
      cell: (s) => <span className="text-xs">{s.representativeName}</span>,
    },
    {
      key: "submittedAt",
      header: "Nộp lúc",
      cell: (s) => (
        <span className="whitespace-nowrap text-xs text-ash">
          {new Date(s.submittedAt).toLocaleString("vi-VN")}
        </span>
      ),
    },
  ];

  const rowActions: RowAction<OrgKycSubmissionAdmin>[] = [
    {
      key: "view",
      label: "Xem chi tiết",
      icon: Eye,
      onClick: (s) => nav(`/kyc/orgs/${s.id}`),
    },
  ];

  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-ink">KYC – Org</h1>
      </header>

      <DataTable
        columns={columns}
        data={items}
        isLoading={isLoading}
        isFetching={isFetching}
        rowKey={(s) => s.id}
        rowActions={rowActions}
        onRowClick={(s) => nav(`/kyc/orgs/${s.id}`)}
        emptyText={t("todoSectionEmptyOrgKyc")}
        page={page}
        pageSize={pageSize}
        total={data?.total}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
      />
    </div>
  );
}
